import {viewActionType as types} from "@constants/admin";


export default {
    name:{
        title: "Name"
    },
    origin:{
        title: "Origin"
    },
    isAvailable:{
        title: "Available",
        type: types.boolean
    },
    enabledTypesObject:{
        title: "Session Types",
        type: types.array,
        property: "name"
    }
};
